import React, { useEffect } from "react";
import { useCart, useCustomer } from "hooks/useStore";
import { trackAddToCart } from "analytics";
import { Script } from "gatsby";
import usePostATCAction from "hooks/usePostATCAction";

const OctaneQuiz = ({ data }) => {
	const { addCartItem } = useCart(["addCartItem"]);
	const customer = useCustomer();
	const { id, scriptId, isAbTest, mobileHeight, desktopHeight } = data;
	const postAddToCartAction = usePostATCAction();

	const handleAddToCart = async (event) => {
		const { id, quantity } = event.detail.items[0];
		await addCartItem(`gid://shopify/ProductVariant/${id}`, +quantity);
		trackAddToCart({ variant: { ...event.detail.items[0] } }, customer);
		postAddToCartAction();
	};

	useEffect(() => {
		window.addEventListener("octane.quiz.addToCart", handleAddToCart);
	}, []);

	return (
		<>
			<Script
				async
				src={`https://app.octaneai.com/${scriptId}/quiz.js`} />
			<div
				className="octane-ai-quiz"
				data-quiz-id={isAbTest ? undefined : id}
				data-abtest-id={isAbTest ? id : undefined}
				data-embed-type="fullpage"
				data-mobile-height={mobileHeight ? `${mobileHeight}px` : "match_browser"}
				data-desktop-height={desktopHeight ? `${desktopHeight}px` : "match_browser"}
			></div>
		</>
	);
};

export default OctaneQuiz;
